'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const genres = [
  { id: 'genre-all', label: 'All', icon: 'FilmIcon' },
  { id: 'genre-action', label: 'Action', icon: 'BoltIcon' },
  { id: 'genre-drama', label: 'Drama', icon: 'HeartIcon' },
  { id: 'genre-scifi', label: 'Sci-Fi', icon: 'RocketLaunchIcon' },
  { id: 'genre-horror', label: 'Horror', icon: 'ExclamationTriangleIcon' },
  { id: 'genre-comedy', label: 'Comedy', icon: 'FaceSmileIcon' },
  { id: 'genre-thriller', label: 'Thriller', icon: 'EyeIcon' },
  { id: 'genre-romance', label: 'Romance', icon: 'SparklesIcon' },
  { id: 'genre-animation', label: 'Animation', icon: 'PaintBrushIcon' },
  { id: 'genre-documentary', label: 'Documentary', icon: 'CameraIcon' },
  { id: 'genre-fantasy', label: 'Fantasy', icon: 'StarIcon' },
];

export default function GenreFilterStrip() {
  const [activeGenre, setActiveGenre] = useState('genre-all');

  return (
    <div className="mt-8">
      <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide pb-2">
        {genres.map((genre) => (
          <button
            key={genre.id}
            onClick={() => setActiveGenre(genre.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-500 flex-shrink-0 transition-all duration-150 ${
              activeGenre === genre.id
                ? 'genre-chip-active text-foreground'
                : 'genre-chip text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon
              name={genre.icon as Parameters<typeof Icon>[0]['name']}
              size={14}
              className={activeGenre === genre.id ? 'text-primary' : 'text-muted-foreground'}
            />
            {genre.label}
          </button>
        ))}
      </div>
    </div>
  );
}